import { useHistory } from 'react-router-dom';
import { useDashboardConfig } from './useDashboardContext';
import { useAppName } from './useAppName';
import { useModal } from '@topconagriculture/modal';
export const useRedirect = (link) => {
    const config = useDashboardConfig();
    const { FEED_URL } = config;
    const appName = useAppName();
    const history = useHistory();
    const { closeModal } = useModal();
    const redirect = (url) => {
        switch (appName) {
            case 'FEED':
                closeModal();
                history.push(url);
                break;
            case 'DASHBOARD':
                window.location.href = `${FEED_URL}${url}`;
                break;
            default:
                window.location.href = `${FEED_URL}${url}`;
        }
    };
    return link ? () => redirect(link) : (path) => redirect(path);
};
//# sourceMappingURL=useRedirect.js.map